// Format currency with proper locale and currency code
export const formatCurrency = (amount, currency = 'USD') => {
  if (!amount && amount !== 0) return '-';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

// Format date
export const formatDate = (dateString) => {
  if (!dateString) return '-';

  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

// Format date and time
export const formatDateTime = (dateString) => {
  if (!dateString) return '-';

  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Format percentage
export const formatPercentage = (value) => {
  if (!value && value !== 0) return '-';

  return `${value}%`;
};

// Format number with commas
export const formatNumber = (number) => {
  if (!number && number !== 0) return '-';

  return new Intl.NumberFormat('en-US').format(number);
};
